import { ErrorData } from '@membranehq/sdk'
import { ReactNode } from 'react'
import { TbAlertOctagon } from 'react-icons/tb'

export function ErrorNotification({ error, children }: { error: ErrorData | Error | string; children?: ReactNode }) {
  const message = typeof error === 'string' ? error : error.message
  return (
    <div className={`flex items-center rounded-sm px-2 pt-2 pb-2 bg-card bg-opacity-20 text-destructive`}>
      <TbAlertOctagon className='mr-1 middle w-5 h-5 shrink-0' />
      <div className={'grow'}>
        {message}
        {children && <div>{children}</div>}
      </div>
    </div>
  )
}
